//go-top function
var goTop = $('.go-top');
if (goTop != null) {

    $(function(){
      var isVisible = false;
      function updateGoTopVisibility() {
        var st = $(window).scrollTop();
        var docHeight = $(document).height();
        var winHeight = $(window).height();
        var shouldShow = st > 0 && (st + winHeight) >= (docHeight / 2);

        if (shouldShow && !isVisible) {
          $('.go-top').stop(true, true).fadeIn(400);
          isVisible = true;
        } else if (!shouldShow && isVisible) {
          $('.go-top').stop(true, true).fadeOut(400);
          isVisible = false;
        }
      }

      $(window).on('scroll resize', updateGoTopVisibility);
      updateGoTopVisibility();

      //Click event
      $('.go-top').click(function () {
        $("html, body").animate({ scrollTop: "0" }, 500);});
    });

  }